<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h4 class="chapter">HALF A</h4>
<h5 class="chapter">CROWN</h5>
<p class="center01">Jo Walton<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="center03"><span class="small">A TOM DOHERTY ASSOCIATES BOOK</span> <img alt="" src="OEBPS/images/9781429954631_L01.png"/> <span class="small">NEW YORK</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429954631_epub_tp_r1.vue?0b9f6af4